<template>
  <div>
    <MessageInputField @change="submitMessage" />
    <p class="text-xs mt-2">
      <a href="https://devhints.io/markdown" target="_blank">Markdown</a> supported 😉
    </p>
  </div>
</template>

<script>
import MessageInputField from './MessageInputField.vue';

export default {
  components: {
    MessageInputField,
  },
  props: {
    conversationId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async submitMessage(content) {
      try {
        await this.$store.dispatch('ui/conversationMessages/store', {
          conversationId: this.conversationId,
          formData: {
            content,
          },
        });

        this.$emit('created');
      } catch (error) {
        //
      }
    },
  },
};
</script>
